export class MaterialGridRequest{
    unitId?:number;
    itemId?:number;
    saleOrderId?:number;
    status?:string[];
}